import { motion } from "framer-motion";

const Terms = () => {
  return (
    <div className="min-h-screen bg-paris-stone overflow-x-hidden" data-testid="terms-page">
      {/* Hero */}
      <section className="bg-midnight-navy pt-24 pb-12 md:pt-28 md:pb-16">
        <div className="container mx-auto px-4 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="font-heading font-bold text-3xl md:text-4xl text-white mb-3 md:mb-4">
              Terms & Conditions
            </h1>
            <p className="text-paris-stone/70 text-sm md:text-base">Last updated: January 2025</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-10 md:py-16 bg-paris-stone">
        <div className="container mx-auto px-4 max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-2xl shadow-soft p-5 md:p-10"
          >
            <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
              1. Service Overview
            </h2>
            <p className="text-slate-600 mb-6">
              Best Disney Transfer provides private transfer services in the Paris region, 
              including airport transfers, Disneyland transfers, and city tours. By booking 
              our services, you agree to these terms.
            </p>

            <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
              2. Booking & Confirmation
            </h2>
            <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
              <li>Bookings can be made online through our website</li>
              <li>A confirmation email will be sent upon successful booking</li>
              <li>Please verify all details in your confirmation email</li>
              <li>Contact us immediately if any information is incorrect</li>
            </ul>

            <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
              3. Payment Terms
            </h2>
            <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
              <li>Payment is made directly to the driver upon arrival</li>
              <li>We accept cash (EUR) and major credit/debit cards</li>
              <li>Prices are fixed and include all taxes and tolls</li>
              <li>Night surcharge (€10) applies for pickups between 9 PM and 5 AM</li>
            </ul>

            <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
              4. Cancellation Policy
            </h2>
            <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
              <li>Free cancellation up to 24 hours before scheduled pickup</li>
              <li>Cancellations within 24 hours may incur a fee</li>
              <li>No-shows will be charged the full transfer amount</li>
              <li>Contact us as soon as possible to cancel or modify your booking</li>
            </ul>

            <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
              5. Waiting Time
            </h2>
            <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
              <li>Airport pickups: 60 minutes free waiting time after flight landing</li>
              <li>Other pickups: 15 minutes free waiting time</li>
              <li>Additional waiting: €0.50 per minute</li>
              <li>We track flights automatically and adjust for delays</li>
            </ul>

            <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
              6. Passenger Responsibilities
            </h2>
            <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
              <li>Provide accurate booking information</li>
              <li>Be ready at the pickup location at the scheduled time</li>
              <li>Inform us of any changes to your travel plans</li>
              <li>Ensure luggage does not exceed vehicle capacity</li>
              <li>Respect the vehicle and driver</li>
            </ul>

            <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
              7. Child Safety
            </h2>
            <p className="text-slate-600 mb-6">
              Free child seats are available upon request. Please specify the ages of 
              children when booking to ensure appropriate seats are provided. It is the 
              parent/guardian&apos;s responsibility to ensure children are properly secured.
            </p>

            <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
              8. Liability
            </h2>
            <p className="text-slate-600 mb-6">
              Best Disney Transfer is not liable for delays caused by traffic, weather, 
              or other circumstances beyond our control. We are not responsible for 
              missed flights due to passenger delays. Our liability is limited to the 
              value of the booked service.
            </p>

            <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
              9. Complaints
            </h2>
            <p className="text-slate-600 mb-6">
              Any complaints should be reported within 7 days of the service. Please 
              contact us at support@bestdisneytransfer.com with your booking reference 
              and details of your complaint.
            </p>

            <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
              10. Governing Law
            </h2>
            <p className="text-slate-600 mb-6">
              These terms are governed by French law. Any disputes will be subject to 
              the exclusive jurisdiction of the courts of Paris, France.
            </p>

            <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
              11. Contact
            </h2>
            <p className="text-slate-600">
              <strong>Best Disney Transfer</strong><br />
              Paris, France<br />
              Email: support@bestdisneytransfer.com<br />
              Phone: +33 1 23 45 67 89
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
